<template>
	<AppDialog :closeTop="2" :width="520" ref="dialog_container" :dialogName="'RespondConfigurationDialog'">
		<SetupMenu
			@close="close"
			:configurationIds="configurationIds"
			:applyConfigurationsResponseOnDraft="applyConfigurationsResponseOnDraft"
		/>
	</AppDialog>
</template>

<script>
import SetupMenu from '@/views/Flow/configurations/SetupMenu';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
export default {
	name: 'RespondConfigurationDialog',
	props: {
		omitResponse: { type: Boolean },
		configurationIds: { type: Object },
		dialogPromiseHandlers: { type: Object },
		applyConfigurationsResponseOnDraft: { type: Boolean },
	},
	components: {
		AppDialog,
		SetupMenu,
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			this.$refs.dialog_container.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss"></style>
